// extracted by mini-css-extract-plugin
export default {"wrapper":"Tj-z","viewport":"Uj-z","container":"Vj-z","slide":"Wj-z"};